import React from 'react';
import './Banners.scss';
import { getIsYangoRequest } from '../../utils';

export interface BannerProps {
    bgImg?: string;
}

const Banners: React.FC<BannerProps> = ({
    bgImg = 'https://dialogs.s3.yandex.net/dev-console/images/banners/banner%201.png',
}) => {
    if (getIsYangoRequest()) {
        return <></>;
    }
    return (
        <div className="banner" style={{ backgroundImage: `url(${bgImg})` }}>
            <div className="banner__comment">
                <img
                    src="https://dialogs.s3.yandex.net/dev-console/images/alice-logo.svg"
                    alt=""
                    width={20}
                    height={20}
                />
                <span>Работа с Алисой</span>
            </div>
            <div className="banner__title">
                Вакансии
                <br />
                из будущего
            </div>
            <a className="banner__button" href="https://yandex.ru/jobs/services/alice" target="_blank" rel="noreferrer">
                Подробнее
            </a>
        </div>
    );
};

export default Banners;
